export interface ChannelStateProps {
  status: Status[];
}

export interface Status {
  id: string;
  identifier: string;
  chatBotId: string;
  contactIntegration: string;
  createdAt: string;
  deactivatedAt2: string;
  name: string;
  operatorId: string;
  operatorName: string;
  remoteId: string;
  status: string;
  updatedAt: string;
  _id: string;
  image: string;
  qrCode?: string;
  type: string;
  shortName?: string;
  authentication: Authentication;
}

export interface Authentication {
  clientId?: string;
  clientSecret?: string;
  type: string;
  redirectUri?: string;
}

export enum EnumType {
  Whatsapp = 'whatsapp',
  Instagram = 'instagram'
}

export enum EnumTypeAuthentication {
  OAUTH = 'OAUTH',
  QRCODE = 'QRCODE'
}

export enum EnumStatus {
  Disconnected = 'DISCONNECTED',
  Connected = 'CONNECTED',
  WaitingQrCode = 'WAITING_QRCODE',
  Loading = 'LOADING',
  WaitingConnect = 'WAITING_CONNECT'
}
